import { IRoomData } from "./backend/nonauthenticated.generated.types";
import { TIME_RANGES, getStartOfWeek, niceTimeNoSec } from "./utils";
import { AuthService } from "./auth";
import { BackendService } from "./backend";
import { CacheService } from "./cache";
import { MSG_TYPES, subscribe } from "./pub_sub";

export interface IReservationView {
    start: number;
    end: number;
    entered: number;
    start_s: string;
    end_s: string;
    entered_s: string;
    date_s: string;
    length: number;
    x_offset_percent: number;
    y_offset_percent: number;
    height_percent: number;
    text: string;
    is_mine: boolean;
    can_edit: boolean;
    is_group: boolean;
    id: number;
    price: number;
}
export interface IAddButtonWrapper {
    x_offset_percent: number;
    y_offset_percent: number;
    height_percent: number;
    hour: number;
    day_offset: number;
}

/** The first visible hour of the day  */
export const VISIBLE_DAY_OFFSET = 6;
/** Number of visible hours per day */
export const VISIBLE_HOURS_PER_DAY = (24 - VISIBLE_DAY_OFFSET);
